<template>
  <div v-if="support" class="preview-container">
    <component
      :is="supportComponent"
      :key="support.id"
      :support-id="support.id"
      :preview="true"
    />
  </div>
  <div v-else class="loading">
    Chargement...
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed, type Ref } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useSupportStore } from "@/stores/supports/useSupportStore";
import AfficheView from "./AfficheView.vue";
import FlyerView from "./FlyerView.vue";
import DepliantView from "./DepliantView.vue";
import BanderoleView from "./BanderoleView.vue";
import EmailingView from "./EmailingView.vue";
import ReseauxView from "./ReseauxView.vue";
import type { Support } from "@/types/support";

const route = useRoute();
const supportStore = useSupportStore();
const support: Ref<Support | null> = ref(null);

const supportTypeMap: Record<string, any> = {
  affiche: AfficheView,
  flyer: FlyerView,
  depliant: DepliantView,
  banderole: BanderoleView,
  emailing: EmailingView,
  social: ReseauxView,
};

const supportComponent = computed(() => {
  if (!support.value) return null;
  // @ts-ignore
  return supportTypeMap[support.value.type as string] || AfficheView;
});

async function getOrRefreshPublicToken() {
  const tokenKey = "auth_token";
  const tokenTimeKey = "auth_token_time";
  const now = Date.now();
  const maxAge = 2 * 60 * 1000; // 2 minutes en ms

  const token = localStorage.getItem(tokenKey);
  const tokenTime = localStorage.getItem(tokenTimeKey);
  if (token && tokenTime && now - parseInt(tokenTime, 10) < maxAge) {
    return token;
  }

  const login = import.meta.env.VITE_PUPPETEER_LOGIN;
  const password = import.meta.env.VITE_PUPPETEER_PASSWORD;
  if (!login || !password) return null;

  const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uuid: login, password }),
  });
  const data = await response.json();
  console.log("data", data);
  if (data.token) {
    localStorage.setItem(tokenKey, data.token);
    localStorage.setItem(tokenTimeKey, now.toString());
    return data.token;
  }
  return null;
}

onMounted(async () => {
  await getOrRefreshPublicToken();
  const id = route.params.id as string;
  const type = (route.query.type as string) || "affiche";
  await supportStore.loadSupport(type, id, true);
  support.value = supportStore.currentSupport;
  supportStore.isPreview = true;
});
</script>

<style scoped>
.preview-container {
  min-height: 100vh;
  background: #f5f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading {
  text-align: center;
  margin-top: 100px;
  font-size: 1.2em;
}
</style>
